// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1df954fe","453":"9cb5468c"}[chunkId] + ".chunk.js";
};